
const baseUri = process.env.REACT_APP_API_URL
const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID
const microsoftClientId = process.env.REACT_APP_MICROSOFT_CLIENT_ID

const env = baseUri?.includes('uatapi')
  ? 'https://uat.etravelmate.com/'
  : 'https://app.etravelmate.com/';
export default {
  baseUri,
  googleClientId,
  microsoftClientId,
  env,
  imgUrl: baseUri + '/user-reg/get-files/img-file?fileurl=',
  mycurrentServer:
    typeof window != 'undefined'
      ? window.location.origin
      : 'https://' +
      (baseUri.includes('uatapi') ? 'uat' : 'app') +
      '.etravelmate.com',
  auth: {
    getOTP: `${baseUri}/userauth/authenticateUser`,
    verifyOTP: `${baseUri}/userauth/verifyLoginOtp`,
    verifyToken: `${baseUri}/userauth/verifyauthtoken`,
    getbyId: `${baseUri}/user-reg/employee-reg/`,
    ssoUserLogin: `${baseUri}/userauth/ssoUserLogin`,
    ciscoSSOLogin: `${baseUri}/userauth/auth/callback`,
    ssoUserLoginMail: `${baseUri}/userauth/ssoUserLoginCred`,
    switchRole: `${baseUri}/userauth/switchUserRole`,
    refreshToken: `${baseUri}/userauth/refresh-token`,
    logoutApi: `${baseUri}/userauth/logOut`,
    loginWithPassword: `${baseUri}/userauth/verifyLoginPassword`,
    signupWithPassword: `${baseUri}/userauth/signup-with-password`,
    forgotPassword: `${baseUri}/userauth/forgotPassword`,
    resetPassword: `${baseUri}/userauth/resetPassword`,
    validateForgotPasswordToken: `${baseUri}/userauth/validateForgotPasswordToken`,
    updatePassword: `${baseUri}/userauth/updateLoginPassword`,
    getPasswordPolicy: `${baseUri}/userauth/getPasswordComplexityPolicyByCorporateId`,
    getPasswordPolicyByLoginId: `${baseUri}/userauth/getPasswordPolicyByLoginId`,
    setPasswordPolicy: `${baseUri}/userauth/setPasswordComplexityPolicy`,
  },
  file: {
    filedownload: `${baseUri}/user-reg/get-files`,
  },
  ratecard: {
    saveRatecard: `${baseUri}/user-reg/trip-ratecard/save`,
    getlist: `${baseUri}/user-reg/trip-ratecard`,
    saveRateCard: `${baseUri}/user-reg/trip/ratecard/save`,
    getRateCardById: `${baseUri}/user-reg/trip/ratecard/`,
  },
  trip: {
    saveRatecard: `${baseUri}/user-reg/rateCard-corp`,
    getsaveRatecard: `${baseUri}/user-reg/rateCard-corp`,
    tripRequest: `${baseUri}/user-reg/trip-req`,
    updateTripStartTime: `${baseUri}/user-reg/trip-route/update-trip-start-time`,
    tripAuditEvents: `${baseUri}/user-reg/trip-route/get-trip-audit-events`,
    vendortripList: `${baseUri}/user-reg/trip-route/search-vendor-trips-list`,
    tripList: `${baseUri}/user-reg/trip-route/search-corporate-trips-list`,
    addEmp: `${baseUri}/user-reg/trip-altr/add`,
    removeEmp: `${baseUri}/user-reg/trip-altr/remove`,
    delinkEmp: `${baseUri}/user-reg/trip-altr/delink`,
    getTripById: `${baseUri}/user-reg/trip-route/get-trip-by-id`,
    // Trip setting restrictions by tripRouteId (per-trip)
    tripSettingRestriction: `${baseUri}/user-reg/trip-route/trip-setting/restriction`,
    // The path id is the trip's _id, which the route list carries as trip.id.
    updateRouteName: (tripId) =>
      `${baseUri}/user-reg/trip-route/trips/${tripId}/route-name`,
  },

  nodal: {
    nodalpoint: `${baseUri}/user-reg/nodal-point`,
  },
  nodalpoint: {
    nodalpointapi: `${baseUri}/user-reg/nodal-point`,
  },
  routes: {
    create: `${baseUri}/user-reg/generate-routes`,
    getDist: `${baseUri}/user-reg/getdist/`,
    getallgeneratedroutes: `${baseUri}/user-reg/generate-routes/getallgeneratedroutes`,
    assignToDriverList: `${baseUri}/user-reg/trip-route/get-vendor-trips-list-by-driverstatus/`,
    assignToVendorList: `${baseUri}/user-reg/trip-route/get-corptrips-list-by-vendorstatus/`,
    assignToVendor: `${baseUri}/user-reg/trip-route/assign-trips-vendor`,
    assignToDriver: `${baseUri}/user-reg/trip-route/assign-trips-to-driver`,
    addRoutingRule: `${baseUri}/user-reg/routing-rule/save`,
    getRoutingRuleByCorporateId: `${baseUri}/user-reg/routing-rule/get-by-corporate-id/`,
    officeRoute: `${baseUri}/user-reg/office-route/getbycorp-id/`,
    createOfficeRoute: `${baseUri}/user-reg/office-route/save-Ofiice-Route`,
  },
  masters: {
    getallBank: `${baseUri}/master/bank/status/Active`,
    getallShift: `${baseUri}/user-reg/shift`,
    getallDept: `${baseUri}/user-reg/department`,
    getallNodal: `${baseUri}/user-reg/NodalPoints`,
    addnodalpoint: `${baseUri}/user-reg/office-route/add-nodalpoint`,
    deleteRouteOfc: `${baseUri}/user-reg/office-route/route/`,
    deleteNodal: `${baseUri}/user-reg/office-route/remove-nodalpoint/`,
    getAllDeptByCorporate: `${baseUri}/user-reg/department/null/employeeId/`,
    getAllvtypecost: `${baseUri}/user-reg/vehicletypecost/getAll`,
    bulkUploadApi: `${baseUri}/bulk-upload/api/v1/bulk-file-upload`,

    // Employee bulk edit (spec 010). Read-only routes only: a preview and its two downloads. Applying
    // a previewed file goes through bulkUploadApi above, like every other bulk upload -- there is no
    // confirm endpoint, deliberately, so this feature has no write path of its own.
    employeeBulkEdit: {
      preview: `${baseUri}/bulk-upload/api/v1/bulk-file-upload/employee-edit/preview`,
      // The two downloads are returned by the preview as absolute paths under the gateway, so they are
      // prefixed rather than templated here -- the server decides which exist.
      downloadBase: `${baseUri}/bulk-upload`,
    }
    // getallNodal:'${baseUri}/user-reg/NodalPoints'
  },
  roaster: {
    roasterListByCreator: `${baseUri}/user-reg/roaster/roasterlistbycreater`,
    roasterCreation: `${baseUri}/user-reg/roaster/creation`,
    roasterUpdate: `${baseUri}/user-reg/roaster/roaster-update`,
    getbyid: `${baseUri}/user-reg/roaster/`,
    getemployeebyshiftandtime: `${baseUri}/user-reg/roaster/getemployeebyshiftandtime?shiftId=`,
    roasterrequest: `${baseUri}/trip/ticket/roasterrequest/YES`,
    getcreatedRoasterNew: `${baseUri}/user-reg/roaster/roasterlistbycreater/`,
    createRoasterNew: `${baseUri}/user-reg/roaster/creation`,
    roasterReqList: `${baseUri}/trip/ticket/roasterrequest/YES`,
    roastersetting: `${baseUri}/user-reg/Roaster-Setting/save-roastersetting`,
    // POST {fromDate, departmentIds, siteOfficeIds} - per-date scheduled / not scheduled / OFF
    // counts behind the Schedule date hover card.
    scheduleStatusCounts: `${baseUri}/user-reg/roaster/schedule-status-counts`,
    // POST {fromDate, shiftType, departmentIds, siteOfficeIds, scheduleStatuses} -> .xlsx of the
    // employees behind a count in that card.
    downloadScheduleStatusReport: `${baseUri}/user-reg/roaster/download-schedule-status-report`,
    // POST {departmentIds: [...]} - settings for every selected department in one call.
    roastersettingsByDepartments: `${baseUri}/user-reg/Roaster-Setting/getroastersettings/departmentIds`,
    roastersettingByDepartment: `${baseUri}/user-reg/Roaster-Setting/getroastersetting`,
  },
  onBoardTenant: {
    list: `${baseUri}/user-reg/tenant-reg`,
    changeRequest: `${baseUri}/user-reg/tenant-change`,
    getChangeRequest: `${baseUri}/user-reg/tenant-change`,
    approve: `${baseUri}/user-reg/tenant-change/approve`,
    reject: `${baseUri}/user-reg/tenant-change/reject`,
  },
  holiday: {
    holidayList: `${baseUri}/user-reg/siteoffice-holyday/getholidaybycorporate`,
    createHoliday: `${baseUri}/user-reg/siteoffice-holyday/save`,
  },
  onBoardCorporate: {
    list: `${baseUri}/user-reg/corporate-reg`,
    changeRequest: `${baseUri}/user-reg/corporate-change`,
    getChangeRequest: `${baseUri}/user-reg/corporate-change`,
    pendingCorp: `${baseUri}/user-reg/corporate-change/`,
  },
  employee: {
    list: `${baseUri}/user-reg/employee-reg`,
    changeRequest: `${baseUri}/user-reg/employee-change`,
    byEmployeeCode: `${baseUri}/user-reg/employee-reg/getByEmpCodeOrEmailId`,
    getAllManager: `${baseUri}/user-reg/employee-reg/fetch/`,
    employeeloginrequest: `${baseUri}/user-reg/employee-request/newemployeereq`,
    adminEmployee: `${baseUri}/user-reg/employee-reg/admin-as-employee`
  },
  driver: {
    list: `${baseUri}/user-reg/driver-reg`,
    shift: `${baseUri}/user-reg/driver-shift`,
    changeRequest: `${baseUri}/user-reg/driver-change`,
    driverMap: `${baseUri}/user-reg/vehicle-driver-mapping`,
    approve: `${baseUri}/user-reg/driver-change/approve`,
    reject: `${baseUri}/user-reg/driver-change/reject`,
    freeDriver: `${baseUri}/user-reg/driver-reg/get-all-free-driver-by-vendor`,
  },
  vehicle: {
    list: `${baseUri}/user-reg/vehicle-reg`,
    vendor: `${baseUri}}/user-reg/vehicle-reg/v007/vendor`,
    createComp: `${baseUri}/user-reg/vehicle`,
    findbyvehicleId: `${baseUri}/user-reg/vehicle/findbyregvehicleid?regVehicleId=`,
  },
  garage: {
    list: `${baseUri}/user-reg/garage/list`,
  },
  vendor: {
    list: `${baseUri}/user-reg/vendor-reg`,
    changeRequest: `${baseUri}/user-reg/vendor-change`,
    associateVendorList: `${baseUri}/user-reg/associatevendor/getallassociatecorporateId
        `,
  },
  siteOffice: {
    list: `${baseUri}/user-reg/siteoffice-reg`,
    activeList: `${baseUri}/user-reg/siteoffice-reg/getAllSiteOfficeByCorporateId`,
  },

  // v2 carries the pickupType choice (HOME / NODAL / CUSTOM) and requires an active site office.
  // The v1 paths are still live for any caller that has not moved over.
  adhocTrip: {
    createV2: `${baseUri}/user-reg/adhoc-trip/create-adhoc-request-v2`,
    createByCorporateV2: `${baseUri}/user-reg/adhoc-trip/create-adhoc-request-by-corporate-v2`,
    updateV2: `${baseUri}/user-reg/adhoc-trip/update-adhoc-request-v2`,
    getById: `${baseUri}/user-reg/adhoc-trip/get-adhoc-request-by-id`,
  },

  masterBank: {
    createform: `${baseUri}/master/bank`,
    list: `${baseUri}/master/bank/status`,
    id: `${baseUri}/master/bank/id`,
  },
  support: {
    topicCreate: `${baseUri}/user-reg/helpmaster/savehelpmaster`,
    deleteTopic: `${baseUri}/user-reg/helpmaster/deactivatehelptopic/`,
    deleteSubTopic: `${baseUri}/user-reg/subtopiccontroller/deactivatesubtopic/`,
    topicUpdate: `${baseUri}/user-reg/helpmaster/updatehelpmaster`,
    topicList: `${baseUri}/user-reg/helpmaster/getAll`,
    gettopicbyid: `${baseUri}/user-reg/helpmaster/`,
    subtopicCreate: `${baseUri}/user-reg/subtopiccontroller/savesubtopic`,
    subtopicUpdate: `${baseUri}/user-reg/subtopiccontroller/updatesubtopic`,
    subtopicList: `${baseUri}/user-reg/subtopiccontroller/getAll`,
    getsubtopicbyid: `${baseUri}/user-reg/subtopiccontroller/`,
    getSubtopicbyTopicid: `${baseUri}/user-reg/subtopiccontroller/`,
    getAllFAQs: `${baseUri}/user-reg/faqcontroller/getAll`,
    saveFAQ: `${baseUri}/user-reg/faqcontroller/savefaqcontroller`,
    updateFAQ: `${baseUri}/user-reg/faqcontroller/updatefaqcontroller`,
    getFAQbyid: `${baseUri}/user-reg/faqcontroller/`,
    getFAQsBySubTopic: `${baseUri}/user-reg/faqcontroller/`,
    raiseTicket: `${baseUri}/user-reg/ticket`,
    getAllTicket: `${baseUri}/user-reg/ticket/getall`,
    getTicketById: `${baseUri}/user-reg/ticket/getbyId/`,
    getTicketByEMPId: `${baseUri}/user-reg/ticket/getTicketByEmployeeId/`,
  },
  masterFueltype: {
    createform: `${baseUri}/master/fueltype`,
    list: `${baseUri}/master/fueltype/status`,
    id: `${baseUri}/master/fueltype/id`,
  },
  masterVehicletype: {
    createform: `${baseUri}/user-reg/vehicletype/addvehicletype`,
    list: `${baseUri}/user-reg/vehicletype/getallvehicletype`,
    id: `${baseUri}/user-reg/vehicletype/vehicletypeId?id=`,
    update: `${baseUri}/user-reg/vehicletype/updatevehicletype`,
    listbytanent: `${baseUri}/user-reg/vehicletype/vehicletypeBycorporateId`,
    delete: `${baseUri}//user-reg/vehicletype`,
  },
  drivershift: {
    createform: `${baseUri}/user-reg/driver-shift`,
    list: `${baseUri}/user-reg/driver-shift`,
  },
  download: {
    download: `${baseUri}/user-reg/get-files`,
  },

  escort: {
    createform: `${baseUri}/user-reg/escort-reg`,
  },

  department: {
    list: `${baseUri}/user-reg/department`,
  },

  manageshifts: {
    createform: `${baseUri}/user-reg/shift`,
    list: `${baseUri}/user-reg/shift`,
    getlistbyCorporate: `${baseUri}/user-reg/shift/`,
  },

  costCenter: {
    list: `${baseUri}/user-reg/cost-center/active`
  },

  compliance: {
    getdriverCompliance: `${baseUri}/user-reg/driver-compliance`,
    saveVehicleCompliance: `${baseUri}/user-reg/vehicle/savecomplianceofvehicle`,
  },

  mobileNo: {
    mobileCheck: `${baseUri}}/userauth/user-account`,
  },

  specialEmployee: {
    create: `${baseUri}/user-reg/special-employee/save-SpecialEmployeeCategory`,
    update: `${baseUri}/user-reg/special-employee/update-SpecialEmployeeCategory`,
    getall: `${baseUri}/user-reg/special-employee/getAll`,
    getbyId: `${baseUri}/user-reg/special-employee`,
  },

  vehicleTypeCost: {
    create: `${baseUri}/user-reg/vehicletypecost/addvehicletypecost`,
    update: `${baseUri}/user-reg/vehicletypecost/updatevehicletypecost`,
    getall: `${baseUri}user-reg/vehicletypecost/getAll`,
    getbyId: `${baseUri}/user-reg/vehicletypecost`,
  },

  penalty: {
    create: `${baseUri}/user-reg/penalty-Service/save-penalty`,
    update: `${baseUri}/user-reg/penalty-Service/update-penalty`,
    getall: `${baseUri}/user-reg/penalty-Service/getAll`,
    getbyId: `${baseUri}/user-reg/penalty-Service/`,
    delete: `${baseUri}/user-reg/penalty-Service/deactivatepenalty`,
  },

  employeesignup: {
    getemail: `${baseUri}user-reg/employee-request/savenewdata/`,
    savenewemploye: `${baseUri}/user-reg/employee-request/newemployeereq`,
    getList: `${baseUri}/user-reg/employee-request/getemployeelistbydomain`,
    getNewEmployeebyId: `${baseUri}//user-reg/employee-request/getbyid`,
    approve: `${baseUri}/user-reg/employee-request/savenewemployee`,
  },

  agency: {
    addagency: `${baseUri}/user-reg/Agency-Service/save-agency`,
    getAll: `${baseUri}/user-reg/Agency-Service/getAll`,
  },

  internalagency: {
    addagency: `${baseUri}/user-reg/internal-reg/save`,
    getall: `${baseUri}/user-reg/internal-reg/getAll`,
  },

  mastershifttype: {
    addshifttype: `${baseUri}/user-reg/shiftType-reg/save`,
    getall: `${baseUri}/user-reg/shiftType-reg/getAll`,
  },

  designation: {
    savedesignation: `${baseUri}/user-reg/bussiness-unit/save-desig`,
    designationList: `${baseUri}/user-reg/designation/getbytanentId`,
    getbyid: `${baseUri}/user-reg/bussiness-unit/getDesig`,
    update: `${baseUri}/user-reg/bussiness-unit/update-desig`,
    delete: `${baseUri}/user-reg/bussiness-unit/desig`,
  },

  businessUnit: {
    saveform: `${baseUri}/user-reg/bussiness-unit/save-bunit`,
    list: `${baseUri}/user-reg/bussiness-unit/getbycorporateId`,
    getbyId: `${baseUri}/user-reg/bussiness-unit/getbyid`,
    deletebU: `${baseUri}/user-reg/bussiness-unit/bu`,
    update: `${baseUri}/user-reg/bussiness-unit/update-bunit`,
  },

  employeeCategory: {
    saveemployeeCategory: `${baseUri}/user-reg/employee-category/save-empcategory`,
    updateemployeeCategory: `${baseUri}/user-reg/employee-category/update-empcategory`,
    employeeCategoryList: `${baseUri}/user-reg/employee-category/getbytanentId`,
    getbyId: `${baseUri}/user-reg/employee-category/getbyid`,
    delete: `${baseUri}/user-reg/employee-category/del-empcategory`,
  },

  token: {
    tokenapi: `${baseUri}/userauth/app/mapkey`,
    // tokenapi: `https://devapi.etravelmate.com/userauth/app/mapkey`
  },

  dropdown: {
    department: `${baseUri}/user-reg/department/dp-department`,
    vendor: `${baseUri}/user-reg/vendor-reg/dp-vendor`,
    shiftmanagement: `${baseUri}/user-reg/shift/dp-getallshift`,
    escortagency: `${baseUri}/user-reg/Agency-Service/dp-getallagency`,
    driveragency: `${baseUri}/user-reg/internal-reg/dp-getallinternalagency`,
  },
  leave: {
    save: `${baseUri}/user-reg/leave-reg/save-leave`,
    update: `${baseUri}/user-reg/leave-reg/update-leave`,
    getbyid: `${baseUri}/user-reg/leave-reg/getbyid/`,
    getScheduleLeave: `${baseUri}/user-reg/roaster/getByFilters`,
    getAll: `${baseUri}/user-reg/leave-reg/getByFilters`,
    postLeaveSetting: `${baseUri}/user-reg/leave-setting/save-leave-setting`,
    getAllLeaveSetting: `${baseUri}/user-reg/leave-setting/getall`,
    getLeaveSettingById: `${baseUri}/user-reg/leave-setting/getbyDepartmentId/`,
    getLeaveSettingByDeptId: `${baseUri}/user-reg/leave-setting/getbyDepartmentId/`,
    updateLeaveSetting: `${baseUri}/user-reg/leave-setting/update-leave-setting`,
  },
  safeReach: {
    create: `${baseUri}/user-reg/safe-reach-setting/create`,
    update: `${baseUri}/user-reg/safe-reach-setting/update-safe-reach`,
    getByCorpId: `${baseUri}/user-reg/safe-reach-setting/get-by-corporateId`,
  },
  safeReachSettings: {
    getById: `${baseUri}/user-reg/safe-reach-settings/`,
    save: `${baseUri}/user-reg/safe-reach-settings/save`,
  },
  tripNotificationCutoff: {
    getByCorporateId: `${baseUri}/user-reg/trip-notification-cutoff/`,
    save: `${baseUri}/user-reg/trip-notification-cutoff/save`,
  },
  networkEvents: {
    search: `${baseUri}/user-reg/trip-route/network-events`,
  },
  tripNotification: {
    history: (tripId) => `${baseUri}/user-reg/trip-notification/history/${tripId}`,
    manualNotify: `${baseUri}/user-reg/trip-notification/manual-notify`,
    manualNotifyShift: `${baseUri}/user-reg/trip-notification/manual-notify-shift`,
    shiftSummary: `${baseUri}/user-reg/trip-notification/shift-summary`,
  },
  safeReachMonitoring: {
    escalated: `${baseUri}/user-reg/safe-reach/escalated`,
    markSafe: `${baseUri}/user-reg/safe-reach/mark-safe`,
    notAnswered: `${baseUri}/user-reg/safe-reach/not-answered`,
  },

  sos: {
    sosSettingSave: `${baseUri}/user-reg/sos-setting/save-sos-setting`,
    sosSettingUpdate: `${baseUri}/user-reg/sos-setting/update-sos-setting`,
    sosSettingById: `${baseUri}/user-reg/sos-setting/get-sos-setting-byid/`,
    // sosSettingList: `${baseUri}/user-reg/sos-setting/getall`,
    sosSettingList: `${baseUri}/user-reg/sos-setting/get-sos-setting-by-corpId/`,
  },

  shiftType: {
    getAll: `${baseUri}/user-reg/shiftType-reg/getAll`,
    getbyId: `${baseUri}/user-reg/shiftType-reg/getById`,
    update: `${baseUri}/user-reg/shiftType-reg/update`,
  },

  dashBoard: {
    dashBoardTripList: `${baseUri}/api/dashboard/analytics/shifts`,
  },

  announcement: {
    create: `${baseUri}/user-reg/announcement/save-announcement`,
    update: `${baseUri}/user-reg/announcement/update-announcement`,
    listing: `${baseUri}/user-reg/announcement/getbycorpoarteid/ACTIVE`,
    getbyId: `${baseUri}/user-reg/announcement/getbyid`,
    empAnnounceList: `${baseUri}/user-reg/announcement/getbyEmpId`,
  },
  setting: {
    notificationSettingSave: `${baseUri}/user-reg/push-not-config/save-push-notification-setting`,
    notificationSettinggetAll: `${baseUri}/user-reg/push-not-config/get-all-push-notification-setting`,
    notificationSettingUpdate: `${baseUri}/user-reg/push-not-config/update-push-notification-setting`,
  },
  incident: {
    getIncidentDataByTripId: `${baseUri}/user-reg/incident-management/getIncidentDataByTripId`,
  },
  publicLiveTracking: {
    postAllTokens: `${baseUri}/node/share`,
    getValidateToken: `${baseUri}/node/validate`,
    // Authoritative single-trip snapshot for the public tracking page.
    tripSnapshot: (tripId) => `${baseUri}/node/trip/${tripId}/snapshot`,
  },
  liveTracking: {
    // Authoritative current-trip snapshot for the live tracking dashboard.
    // clientType: 'corporate' | 'vendor'; id: corporateId (corporate) or profileId (vendor)
    currentTrips: (clientType, id) => `${baseUri}/node/${clientType}/${id}/trips`,
  },
  overallFeedback: {
    getAll: `${baseUri}/user-reg/overall-feedback/get-all-overall-feedback`,
    getById: `${baseUri}/user-reg/overall-feedback/get-overall-feedback-by-id/`,
    save: `${baseUri}/user-reg/overall-feedback/save-overall-feedback`,
    update: `${baseUri}/user-reg/overall-feedback/update-overall-feedback`,
    deactivate: `${baseUri}/user-reg/overall-feedback/deActivate-overall-feedback/`,
    reactivate: `${baseUri}/user-reg/overall-feedback/reActivate-overall-feedback/`,
  },
  feedbackSettings: {
    getById: `${baseUri}/user-reg/feedback-settings/get-by-corporateId/`,
    save: `${baseUri}/user-reg/feedback-settings/save`,
    update: `${baseUri}/user-reg/feedback-settings/update`,
    activeCategories: `${baseUri}/user-reg/feedback-settings/active-categories/`,
  },
  feedbackReport: {
    getHeaders: `${baseUri}/user-reg/feedback-report/getHeaders/`,
    list: `${baseUri}/user-reg/feedback-report/list/`,
    download: `${baseUri}/user-reg/feedback-report/download-report/`,
  },
  // TEMPORARY — Fair Cab Allocation Simulator (remove with FairCabSimulator feature)
  fairCabSimulator: {
    simulate: `${baseUri}/user-reg/vendorAllocationContract/simulate`,
  },
  fuelPrice: {
    list: `${baseUri}/user-reg/fuelPrice/getAllFuelPriceCorporateLevelWithCorporateId`,
    getById: `${baseUri}/user-reg/fuelPrice/getFuelPriceCorporateById`,
    create: `${baseUri}/user-reg/fuelPrice/saveFuelPriceWithDateRange`,
    update: `${baseUri}/user-reg/fuelPrice/updateFuelPriceCorporateLevel`,
    delete: `${baseUri}/user-reg/fuelPrice/deleteFuelPriceCorporateById`,
    activateDeactivate: `${baseUri}/user-reg/fuelPrice/activateDeactivateFuelPrice`,
  },
  cabId: {
    list: `${baseUri}/user-reg/cab-id/list`,
    getById: `${baseUri}/user-reg/cab-id/`,
    create: `${baseUri}/user-reg/cab-id`,
    update: `${baseUri}/user-reg/cab-id/`,
    deactivate: `${baseUri}/user-reg/cab-id/deactivate/`,
    activate: `${baseUri}/user-reg/cab-id/activate/`,
    eligible: `${baseUri}/user-reg/cab-id/eligible`,
    activeCabId: `${baseUri}/user-reg/cab-id/activeCabId`,
  },
  routingSchema: {
    create: `${baseUri}/user-reg/routing-schema`,
    filter: `${baseUri}/user-reg/routing-schema/filter`,
    getById: (id) => `${baseUri}/user-reg/routing-schema/${id}`,
    update: (id) => `${baseUri}/user-reg/routing-schema/${id}`,
    toggleStatus: (id) => `${baseUri}/user-reg/routing-schema/toggle-status/${id}`,
    active: `${baseUri}/user-reg/routing-schema/active`,
    download: (id) => `${baseUri}/user-reg/routing-schema/${id}/download`,
  },
  shuttleMaster: {
    create: `${baseUri}/user-reg/shuttle-master`,
    list: `${baseUri}/user-reg/shuttle-master/list`,
    getById: (id) => `${baseUri}/user-reg/shuttle-master/${id}`,
    update: (id) => `${baseUri}/user-reg/shuttle-master/${id}`,
    remove: (id) => `${baseUri}/user-reg/shuttle-master/${id}`,
    generateRoute: `${baseUri}/user-reg/shuttle-master/generate-route`,
    generateTrips: (id) => `${baseUri}/user-reg/shuttle-master/${id}/generate-trips`,
  },
  shuttleTrip: {
    // WS3 — edit a shuttle trip's stop ETAs + count upcoming sibling trips of the route.
    stopEta: (tripId) => `${baseUri}/user-reg/shuttle-trip/${tripId}/stop-eta`,
    upcomingSiblings: (tripId) => `${baseUri}/user-reg/shuttle-trip/${tripId}/upcoming-siblings`,
  },
};